import createIcon from '../../createIcon';

/**
 * @component @name PersonalInjury
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOCA2QzggMy43OSA5Ljc5IDIgMTIgMkMxNC4yMSAyIDE2IDMuNzkgMTYgNkMxNiA4LjIxIDE0LjIxIDEwIDEyIDEwQzkuNzkgMTAgOCA4LjIxIDggNlpNMTcgMjJIMThDMTkuMSAyMiAyMCAyMS4xIDIwIDIwVjE1LjIyQzIwIDE0LjEgMTkuMzkgMTMuMDcgMTguMzkgMTIuNTZDMTcuOTYgMTIuMzQgMTcuNDkgMTIuMTMgMTcgMTEuOTRWMjJaTTEyLjM0IDE3TDE1IDExLjMzQzE0LjA3IDExLjEyIDEzLjA3IDExIDEyIDExQzkuNDcgMTEgNy4yOSAxMS43IDUuNjEgMTIuNTZDNC42MSAxMy4wNyA0IDE0LjEgNCAxNS4yMlYyMkg2LjM0QzYuMTIgMjEuNTUgNiAyMS4wNCA2IDIwLjVDNiAxOC41NyA3LjU3IDE3IDkuNSAxN0gxMi4zNFpNMTAgMjJMMTEuNDEgMTlIOS41QzguNjcgMTkgOCAxOS42NyA4IDIwLjVDOCAyMS4zMyA4LjY3IDIyIDkuNSAyMkgxMFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PersonalInjury = createIcon('PersonalInjury', [
  [
    'path',
    {
      d: 'M8 6C8 3.79 9.79 2 12 2C14.21 2 16 3.79 16 6C16 8.21 14.21 10 12 10C9.79 10 8 8.21 8 6ZM17 22H18C19.1 22 20 21.1 20 20V15.22C20 14.1 19.39 13.07 18.39 12.56C17.96 12.34 17.49 12.13 17 11.94V22ZM12.34 17L15 11.33C14.07 11.12 13.07 11 12 11C9.47 11 7.29 11.7 5.61 12.56C4.61 13.07 4 14.1 4 15.22V22H6.34C6.12 21.55 6 21.04 6 20.5C6 18.57 7.57 17 9.5 17H12.34ZM10 22L11.41 19H9.5C8.67 19 8 19.67 8 20.5C8 21.33 8.67 22 9.5 22H10Z',
      key: 'kljmpj',
    },
  ],
]);

export default PersonalInjury;
